import React from 'react';

export default function VvCheckpointCard({ title, description, active }) {
    return <div className={`vv-checkpoint-card ${active ? "selected" : ""}`}>
        <div className="vv-checkpoint-card-title"><b>{title}</b></div>
        <div className="vv-checkpoint-card-description" dangerouslySetInnerHTML={{__html: description}}></div>
    </div>
}